document.addEventListener("DOMContentLoaded", function () {
  console.log('working saif code')
  
  // Ensure the modal trigger element exists
  
  const modalTrigger = document.querySelector('[data-modalbox="true"]');
  
  console.log(modalTrigger)

  if (!modalTrigger) {
    console.error("Modal trigger not found. Ensure the element with `data-modalbox='true'` exists in the DOM.");
    return;
  }

  // hamza code start
  document.addEventListener('click', function(e){
    if(e.target.classList.contains('entry--content')){
      console.log("Modal trigger clicked"); // Debugging

      // Check if a modal already exists
      if (document.querySelector(".language-modal-overlay")) {
        console.log("Modal already exists. Skipping creation.");
        return;
      }

      // Get the language data
      const languageString = modalTrigger.getAttribute("data-language");
      console.log("Language data:", languageString); // Debugging

      // Parse the languages
      const languages = languageString ? languageString.split(",").map(lang => lang.trim()) : [];
      console.log("Parsed languages:", languages); // Debugging

      // Create modal container
      const modal = document.createElement("div");
      modal.className = "language-modal-overlay";

      // Create modal content structure
      const modalContent = document.createElement("div");
      modalContent.className = "language-modal-content";

      // Create close button
      const closeButton = document.createElement("button");
      closeButton.innerHTML = "&times;";
      closeButton.className = "language-modal-close";
      closeButton.addEventListener("click", function () {
        document.body.removeChild(modal);
      });

      // Create header
      const header = document.createElement("div");
      header.className = "language-modal-header";
      header.innerHTML = `
        <div class="language-modal-title">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="m5 8 6 6"></path>
            <path d="m4 14 10-10 6 6-10 10-6-6z"></path>
            <path d="M14 4v6h6"></path>
            <path d="M10 14H4v6"></path>
          </svg>
          <span>Supported Languages</span>
        </div>
      `;

      // Create search section
      const searchContainer = document.createElement("div");
      searchContainer.className = "language-modal-search";
      searchContainer.innerHTML = `
        <label class="language-modal-search-label">List of allowed languages for this product version:</label>
        <div class="language-modal-search-input-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="8"></circle>
            <path d="m21 21-4.3-4.3"></path>
          </svg>
          <input type="search" id="languageSearchInput" placeholder="Search languages..." class="language-search-input">
        </div>
      `;

      // Create languages list container
      const languagesContainer = document.createElement("div");
      languagesContainer.className = "language-modal-list-container";

      // Create languages list
      const languagesList = document.createElement("ul");
      languagesList.id = "languagesList";
      languagesList.className = "language-modal-list";

      if (languages.length === 0 || languages[0] === "No languages available") {
        const noLanguagesMessage = document.createElement("li");
        noLanguagesMessage.className = "language-modal-empty";
        noLanguagesMessage.textContent = "No languages available for this product.";
        languagesList.appendChild(noLanguagesMessage);
      } else {
        languages.forEach(language => {
          const languageItem = document.createElement("li");
          languageItem.className = "language-modal-item";
          languageItem.textContent = language;
          languagesList.appendChild(languageItem);
        });
      }

      // Assemble the modal
      languagesContainer.appendChild(languagesList);
      modalContent.appendChild(closeButton);
      modalContent.appendChild(header);
      modalContent.appendChild(searchContainer);
      modalContent.appendChild(languagesContainer);
      modal.appendChild(modalContent);
      document.body.appendChild(modal);

      // Close modal when clicking outside
      modal.addEventListener("click", function (e) {
        if (e.target === modal) {
          document.body.removeChild(modal);
        }
      });

      // Add search functionality
      const searchInput = document.getElementById("languageSearchInput");
      if (searchInput && languages.length > 0 && languages[0] !== "No languages available") {
        searchInput.addEventListener("keyup", function () {
          const filter = this.value.toUpperCase();
          const items = languagesList.getElementsByTagName("li");

          for (let i = 0; i < items.length; i++) {
            const text = items[i].textContent || items[i].innerText;
            if (text.toUpperCase().indexOf(filter) > -1) {
              items[i].style.display = "";
            } else {
              items[i].style.display = "none";
            }
          }
        });
      } else {
        console.log("Search functionality skipped: No languages available or search input not found.");
      }
    }
  })
  // hamza code end 

  // Add click event listener to the modal trigger
  // modalTrigger.addEventListener("click", function (e) {
  //   e.preventDefault();

  //   console.log("Modal trigger clicked"); // Debugging

  //   // Check if a modal already exists
  //   if (document.querySelector(".language-modal-overlay")) {
  //     console.log("Modal already exists. Skipping creation.");
  //     return;
  //   }

  //   // Get the language data
  //   const languageString = modalTrigger.getAttribute("data-language");
  //   console.log("Language data:", languageString); // Debugging

  //   // Parse the languages
  //   const languages = languageString ? languageString.split(",").map(lang => lang.trim()) : [];
  //   console.log("Parsed languages:", languages); // Debugging

  //   // Create modal container
  //   const modal = document.createElement("div");
  //   modal.className = "language-modal-overlay";

  //   // Create modal content structure
  //   const modalContent = document.createElement("div");
  //   modalContent.className = "language-modal-content";

  //   // Create close button
  //   const closeButton = document.createElement("button");
  //   closeButton.innerHTML = "&times;";
  //   closeButton.className = "language-modal-close";
  //   closeButton.addEventListener("click", function () {
  //     document.body.removeChild(modal);
  //   });

  //   // Create header
  //   const header = document.createElement("div");
  //   header.className = "language-modal-header";
  //   header.innerHTML = `
  //     <div class="language-modal-title">
  //       <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  //         <path d="m5 8 6 6"></path>
  //         <path d="m4 14 10-10 6 6-10 10-6-6z"></path>
  //         <path d="M14 4v6h6"></path>
  //         <path d="M10 14H4v6"></path>
  //       </svg>
  //       <span>Supported Languages</span>
  //     </div>
  //   `;

  //   // Create search section
  //   const searchContainer = document.createElement("div");
  //   searchContainer.className = "language-modal-search";
  //   searchContainer.innerHTML = `
  //     <label class="language-modal-search-label">List of allowed languages for this product version:</label>
  //     <div class="language-modal-search-input-wrapper">
  //       <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  //         <circle cx="11" cy="11" r="8"></circle>
  //         <path d="m21 21-4.3-4.3"></path>
  //       </svg>
  //       <input type="search" id="languageSearchInput" placeholder="Search languages..." class="language-search-input">
  //     </div>
  //   `;

  //   // Create languages list container
  //   const languagesContainer = document.createElement("div");
  //   languagesContainer.className = "language-modal-list-container";

  //   // Create languages list
  //   const languagesList = document.createElement("ul");
  //   languagesList.id = "languagesList";
  //   languagesList.className = "language-modal-list";

  //   if (languages.length === 0 || languages[0] === "No languages available") {
  //     const noLanguagesMessage = document.createElement("li");
  //     noLanguagesMessage.className = "language-modal-empty";
  //     noLanguagesMessage.textContent = "No languages available for this product.";
  //     languagesList.appendChild(noLanguagesMessage);
  //   } else {
  //     languages.forEach(language => {
  //       const languageItem = document.createElement("li");
  //       languageItem.className = "language-modal-item";
  //       languageItem.textContent = language;
  //       languagesList.appendChild(languageItem);
  //     });
  //   }

  //   // Assemble the modal
  //   languagesContainer.appendChild(languagesList);
  //   modalContent.appendChild(closeButton);
  //   modalContent.appendChild(header);
  //   modalContent.appendChild(searchContainer);
  //   modalContent.appendChild(languagesContainer);
  //   modal.appendChild(modalContent);
  //   document.body.appendChild(modal);

  //   // Close modal when clicking outside
  //   modal.addEventListener("click", function (e) {
  //     if (e.target === modal) {
  //       document.body.removeChild(modal);
  //     }
  //   });

  //   // Add search functionality
  //   const searchInput = document.getElementById("languageSearchInput");
  //   if (searchInput && languages.length > 0 && languages[0] !== "No languages available") {
  //     searchInput.addEventListener("keyup", function () {
  //       const filter = this.value.toUpperCase();
  //       const items = languagesList.getElementsByTagName("li");

  //       for (let i = 0; i < items.length; i++) {
  //         const text = items[i].textContent || items[i].innerText;
  //         if (text.toUpperCase().indexOf(filter) > -1) {
  //           items[i].style.display = "";
  //         } else {
  //           items[i].style.display = "none";
  //         }
  //       }
  //     });
  //   } else {
  //     console.log("Search functionality skipped: No languages available or search input not found.");
  //   }
  // });
});